export default __webpack_public_path__ + "static/media/Camera_Off.2f9bedcf.svg";